<div *ngIf="isLoading || !model">Loading User List...</div>

<select *ngIf="!isLoading && model" (change)="optionChanged.emit(true)" [compareWith]="byId" [class.form-control]="!noStyle"
        name="user"
        [(ngModel)]="model.user" [required]="required">
  <option *ngFor="let singleUser of users" [ngValue]="singleUser">{{ singleUser.name }}</option>
</select>
